import { useEffect, useState } from "react";
import { Paper } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import { toast } from "react-toastify";
import {
  getAttorneyUsersByUserId,
  getAttorneyInvitationByUserEmail,
  deleteAttorneyInvite,
  getToken,
  getUser,
  deleteAttorney,
  sendemail,
} from "../services/user-service";
import SideBar from "../components/sidebar/Sidebar";
import UserBase from "../components/user/UserBase";
import "../css/AttorneyForm.css";
import { EmailTemplateForOffboardingAttorney } from "./Emailtemplate";

const AttorneyList = () => {
  const [attorneyData, setAttorneyData] = useState(null);
  const [inviteData, setInviteData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    type: null,
    data: null,
  });

  const fetchAttorneyDetails = () => {
    const token = "Bearer " + getToken();
    const userId = getUser().commonId;
    const userEmail = getUser().email;

    Promise.all([
      getAttorneyUsersByUserId(token, userId),
      getAttorneyInvitationByUserEmail(token, userEmail),
    ])
      .then(([attorneyRes, inviteRes]) => {
        setAttorneyData(attorneyRes.data || []);
        setInviteData(inviteRes || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchAttorneyDetails();
  }, []);

  const handleDeleteInvite = (inviteId) => {
    setDeleteModal({
      isOpen: true,
      type: "invite",
      data: { inviteId },
    });
  };

  const confirmDeleteInvite = () => {
    const token = "Bearer " + getToken();
    const userEmail = getUser().email;
    const { inviteId } = deleteModal.data;

    deleteAttorneyInvite(token, userEmail, inviteId)
      .then(() => {
        setDeleteModal({ isOpen: false, type: null, data: null });
        toast.success("Invite deleted successfully");
        fetchAttorneyDetails();
      })
      .catch(() => {
        setDeleteModal({ isOpen: false, type: null, data: null });
        toast.error("Failed to delete invite");
      });
  };

  const handleDeleteAttorney = (attorneyEmail, attorneyName) => {
    setDeleteModal({
      isOpen: true,
      type: "attorney",
      data: { attorneyEmail, attorneyName },
    });
  };

  const confirmDeleteAttorney = () => {
    const token = "Bearer " + getToken();
    const { attorneyEmail, attorneyName } = deleteModal.data;

    deleteAttorney(token, attorneyEmail)
      .then(() => {
        setDeleteModal({ isOpen: false, type: null, data: null });
        toast.success("Attorney deleted successfully");

        const emailDetails = {
          to: attorneyEmail,
          subject: "Offboarding from I-Chest",
          message: EmailTemplateForOffboardingAttorney(attorneyName),
        };

        const formData = new FormData();
        formData.append("emailDetails", JSON.stringify(emailDetails));

        sendemail(formData)
          .then(() => toast.success("Offboarding email sent"))
          .catch(() => toast.error("Failed to send offboarding email"));

        fetchAttorneyDetails();
      })
      .catch(() => {
        setDeleteModal({ isOpen: false, type: null, data: null });
        toast.error("Failed to delete attorney");
      });
  };

  const closeModal = () => {
    setDeleteModal({ isOpen: false, type: null, data: null });
  };

  if (loading) return <p>Loading...</p>;

  // Modal Styles
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modal: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "24px",
      maxWidth: "400px",
      width: "90%",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    title: {
      margin: "0 0 16px 0",
      fontSize: "18px",
      fontWeight: "600",
      color: "#333",
    },
    message: {
      margin: "0 0 24px 0",
      fontSize: "14px",
      color: "#666",
      lineHeight: "1.5",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "12px",
    },
    button: {
      padding: "8px 16px",
      border: "none",
      borderRadius: "4px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "opacity 0.2s",
    },
    cancelButton: {
      backgroundColor: "#5bc0de",
      color: "#fff",
    },
    deleteButton: {
      backgroundColor: "#d9534f",
      color: "#fff",
    },
  };

  return (
    <UserBase>
      <div style={{ marginTop: "4rem" }} className="otherElement">
        <SideBar>
          {inviteData && inviteData.length > 0 && (
            <div className="beneficiary_list_base">
              <div className="beneficiary_list_main">
                <div className="beneficiary_heading">
                  <h4>Attorney Invites</h4>
                </div>
                <div className="beneficiary_container">
                  <div className="beneficiary_details_cards">
                    <Paper
                      sx={{ padding: 1.5 }}
                      className="beneficiary_detail_card"
                      style={{
                        backgroundColor: "rgb(208,208,208)",
                        width: "fit-content",
                      }}
                    >
                      <p className="beneficiary_row">
                        <strong>Name</strong>
                      </p>
                      <p
                        style={{ minWidth: "190px" }}
                        className="beneficiary_row"
                      >
                        <strong>Email</strong>
                      </p>
                      <p className="beneficiary_row">
                        <strong>Agent Type</strong>
                      </p>
                      <p className="beneficiary_row">
                        <strong>Invitation Accepted</strong>
                      </p>
                      <p className="beneficiary_row">
                        <strong>Rejected</strong>
                      </p>
                      <p className="beneficiary_row">
                        <strong>Created Date</strong>
                      </p>
                      <p className="beneficiary_row">
                        <strong>Action</strong>
                      </p>
                    </Paper>

                    {inviteData.map((invite, index) => (
                      <Paper
                        key={index}
                        sx={{ padding: 1.5 }}
                        className="beneficiary_detail_card"
                        style={{ width: "fit-content" }}
                      >
                        <p className="beneficiary_row beneficiary_row_data">
                          <strong>{invite.agentName}</strong>
                        </p>
                        <p
                          style={{ minWidth: "190px" }}
                          className="beneficiary_row beneficiary_row_data"
                        >
                          {invite.agentEmail}
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          {invite.agentType}
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          {invite.isInvitationAccepted ? "Yes" : "No"}
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          {invite.isRejected ? "Yes" : "No"}
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          {invite.createdDate}
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteInvite(invite.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </p>
                      </Paper>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="beneficiary_list_base">
            <div className="beneficiary_list_main">
              <div className="beneficiary_heading">
                <h4>Attorney/Agent Details</h4>
              </div>
              <div className="beneficiary_container">
                <div className="beneficiary_details_cards">
                  <Paper
                    sx={{ padding: 1.5 }}
                    className="beneficiary_detail_card"
                    style={{
                      backgroundColor: "rgb(208,208,208)",
                      width: "fit-content",
                    }}
                  >
                    <p className="beneficiary_row">
                      <strong>Name</strong>
                    </p>
                    <p
                      style={{ minWidth: "190px" }}
                      className="beneficiary_row"
                    >
                      <strong>Email</strong>
                    </p>
                    <p className="beneficiary_row">
                      <strong>Law Firm</strong>
                    </p>
                    <p className="beneficiary_row">
                      <strong>Bar License No.</strong>
                    </p>
                    <p className="beneficiary_row">
                      <strong>Jurisdiction</strong>
                    </p>
                    <p className="beneficiary_row">
                      <strong>Practice Area</strong>
                    </p>
                    <p className="beneficiary_row">
                      <strong>Years Experience</strong>
                    </p>
                    <p
                      className="beneficiary_row"
                      style={{ minWidth: "240px", textAlign: "center" }}
                    >
                      <strong>Website</strong>
                    </p>
                    <p className="beneficiary_row">
                      <strong>Action</strong>
                    </p>
                  </Paper>

                  {attorneyData && attorneyData.length > 0 ? (
                    attorneyData.map((attorney, index) => (
                      <Paper
                        key={index}
                        sx={{ padding: 1.5 }}
                        className="beneficiary_detail_card"
                        style={{ width: "fit-content" }}
                      >
                        <p className="beneficiary_row beneficiary_row_data">
                          <strong>
                            {attorney.attorneyFirstName}{" "}
                            {attorney.attorneyLastName}
                          </strong>
                        </p>
                        <p
                          style={{ minWidth: "190px" }}
                          className="beneficiary_row beneficiary_row_data"
                        >
                          {attorney.attorneyEmail}
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          {attorney.lawFirmName}
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          {attorney.barAssociationLicenseNumber}
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          {attorney.jurisdictionOfPractice}
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          {attorney.practiceArea}
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          {attorney.yearOfExperience}
                        </p>
                        <p
                          className="beneficiary_row beneficiary_row_data"
                          style={{
                            minWidth: "240px",
                            textAlign: "center",
                          }}
                        >
                          <a
                            href={attorney.websiteUrl}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {attorney.websiteUrl}
                          </a>
                        </p>
                        <p className="beneficiary_row beneficiary_row_data">
                          <IconButton
                            color="error"
                            onClick={() =>
                              handleDeleteAttorney(
                                attorney.attorneyEmail,
                                `${attorney.attorneyFirstName} ${attorney.attorneyLastName}`
                              )
                            }
                          >
                            <DeleteIcon />
                          </IconButton>
                        </p>
                      </Paper>
                    ))
                  ) : (
                    <p>No attorney details found.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </SideBar>
      </div>
      {deleteModal.isOpen && (
        <div style={modalStyles.overlay} onClick={closeModal}>
          <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
            <h3 style={modalStyles.title}>Confirm Delete</h3>
            <p style={modalStyles.message}>
              {deleteModal.type === "invite"
                ? "Are you sure you want to delete this invite?"
                : `Are you sure you want to remove ${deleteModal.data?.attorneyName}?`}
            </p>
            <div style={modalStyles.buttonContainer}>
              <button
                style={{ ...modalStyles.button, ...modalStyles.cancelButton }}
                onClick={closeModal}
                onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                onMouseLeave={(e) => (e.target.style.opacity = "1")}
              >
                No
              </button>
              <button
                style={{ ...modalStyles.button, ...modalStyles.deleteButton }}
                onClick={
                  deleteModal.type === "invite"
                    ? confirmDeleteInvite
                    : confirmDeleteAttorney
                }
                onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                onMouseLeave={(e) => (e.target.style.opacity = "1")}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </UserBase>
  );
};

export default AttorneyList;